module.exports = __webpack_public_path__ + "static/img/placeholder.51060470.png";